export default __webpack_public_path__ + "static/media/q32_v2.33e91785.png";